import { Injectable } from '@angular/core';
import { CoachMarkHttpService } from './coach-mark-http.service';
import { Observable, BehaviorSubject, map } from 'rxjs';
import { CoachMarksModal } from '../models/coachmark.model';


@Injectable({
    providedIn: 'root'
})
export class CoachMarkService {

    currentCoachMarks$: Observable<CoachMarksModal>;
    currentCoachMarksSubject: BehaviorSubject<CoachMarksModal>;

    get currentCoachMarkValue(): CoachMarksModal {
        return this.currentCoachMarksSubject.value;
    }

    set currentCoachMarkValue(coachMarks: CoachMarksModal) {
        this.currentCoachMarksSubject.next(coachMarks);
    }

    constructor(
        private readonly coachMarkHttpService: CoachMarkHttpService,
    ) {
        this.currentCoachMarksSubject = new BehaviorSubject<CoachMarksModal>(undefined);
        this.currentCoachMarks$ = this.currentCoachMarksSubject.asObservable();
    }

    getAllCoachMarks(): Observable<CoachMarksModal> {
        return this.coachMarkHttpService.getCoachMark().pipe(
          map((response: CoachMarksModal) => {
            this.currentCoachMarkValue = response;
            return response;
          })
        )
    }

    updateCoachMarks(request: any): Observable<CoachMarksModal> {
        return this.coachMarkHttpService.updateCoachMark(request).pipe(
            map((response: CoachMarksModal) => {
                this.currentCoachMarkValue = response;
                return response;
            })
        );
    }

    resetCoachMarks(): Observable<CoachMarksModal> {
        return this.coachMarkHttpService.resetCoachMark().pipe(
            map((response: CoachMarksModal) => {
                this.currentCoachMarkValue = response;
                return response;
            })
        );
    }

}
